// extracted by mini-css-extract-plugin
export default {"normal":"A3cMl9","italic":"ANzMq1"};